import { Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ShareholdingFilter } from '../../../generated/model/models';
import { useDefaultValueWatcher } from '../../../hooks/useDefaultValueWatcher';
import { useOnChange } from '../../../hooks/useOnChange';
import ReadableStatementView from '../../Inputs/ReadableStatementView';
import { InputPercentageDropdown } from '../../Inputs/ShareHolderDropdown';
import InputSwitch, { SwitchSize } from '../../Inputs/Switch/Switch';

interface Props {
  root?: boolean;
  onChange: (value: ShareholdingFilter) => void;
  defaultValue?: ShareholdingFilter;
  active: boolean;
}

const SwitchShareholdingFilterInput: React.FC<Props> = React.memo(
  ({
    onChange,
    root,
    active,
    defaultValue = {
      includeOverlappingSubsidiaryOwnership: false,
      percentage: 25,
    },
  }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const [state, setState] = useState<ShareholdingFilter>(defaultValue);

    useDefaultValueWatcher({ defaultValue, state, setState });
    useOnChange(onChange, state, root);

    const rs: any[] = [];
    if (state?.percentage) {
      rs.push({
        label: 'Ownership %:',
        value: state.percentage,
      });
    }
    if (state?.includeOverlappingSubsidiaryOwnership) {
      rs.push({
        label: 'Included:',
        value: t('companies:filterInputs.withOverlappingSubsidiaryOwnership'),
      });
    }

    return (
      <>
        {active ? (
          <Grid container direction="row">
            <Grid container direction="row">
              <InputPercentageDropdown
                onChange={(value) => {
                  setState({ ...state, percentage: Number(value.percentage) });
                }}
                defaultValue={['' + defaultValue.percentage]}
                defaultState={{ percentage: '' + state.percentage! }}
              />
            </Grid>
            <Typography className={classes.typographyUppercase}>
              {t('companies:filterInputs.includeCompanies')}:
            </Typography>
            <Grid item className={classes.gridText}>
              <Typography className={classes.typography}>
                {t('companies:filterInputs.withOverlappingSubsidiaryOwnership')}
              </Typography>
            </Grid>
            <Grid item>
              <InputSwitch
                fieldName=""
                checked={state.includeOverlappingSubsidiaryOwnership}
                onChange={(value) => {
                  setState({ ...state, includeOverlappingSubsidiaryOwnership: value });
                }}
                size={SwitchSize.small}
              />
            </Grid>
          </Grid>
        ) : (
          <ReadableStatementView rows={rs} />
        )}
      </>
    );
  },
);

const useStyles = makeStyles((theme: Theme) => ({
  gridText: {
    width: 'calc(100% - 48px)',
    display: 'flex',
    alignItems: 'center',
  },
  typography: {
    fontSize: theme.typography.fontSize - 2,
  },
  typographyUppercase: {
    fontSize: theme.typography.fontSize - 2,
    textTransform: 'uppercase',
  },
}));

export default SwitchShareholdingFilterInput;
